import { useEffect } from 'react'
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { IGN_PLAN_URL, IGN_ATTRIBUTION } from '@/constants/tiles'

// Fix default marker icon (known Leaflet+webpack issue)
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

function RecenterMap({ latitude, longitude }) {
  const map = useMap()
  useEffect(() => {
    map.invalidateSize()
    map.setView([latitude, longitude])
  }, [map, latitude, longitude])
  return null
}

export default function MapBase({ latitude, longitude, zoom = 15, height = '400px', interactive = true, scrollWheelZoom, children }) {
  if (!latitude || !longitude) return null

  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={zoom}
      style={{ height, width: '100%' }}
      className="rounded-lg z-0"
      dragging={interactive}
      zoomControl={interactive}
      scrollWheelZoom={scrollWheelZoom ?? interactive}
      doubleClickZoom={interactive}
      touchZoom={interactive}
      boxZoom={interactive}
      keyboard={interactive}
    >
      <TileLayer
        url={IGN_PLAN_URL}
        tileSize={256}
        attribution={IGN_ATTRIBUTION}
      />
      <RecenterMap latitude={latitude} longitude={longitude} />
      <Marker position={[latitude, longitude]}>
        <Popup>Bien expertisé</Popup>
      </Marker>
      {children}
    </MapContainer>
  )
}
